import React from 'react';
import ReactDOM from 'react-dom';
import App from './Views';


ReactDOM.render(
  <React.StrictMode>
    <App /> 
  </React.StrictMode>,
  document.getElementById('root')
);
